<div class="ie-field">
  <label *ngIf="label" class="ie-field__label">{{ label }}</label>

  <!-- View mode -->
  <div
    *ngIf="!editing"
    class="ie-field__display"
    [matTooltip]="value"
    (click)="onEdit(value)"
    (focus)="onEdit(value)"
    tabindex="0"
    title="Click to edit"
  >
    <span class="ie-field__value">{{ value || ('Click to edit' | translate) }}</span>
    <i class="fa fa-pencil ie-field__icon"></i>
  </div>

  <!-- Edit mode -->
  <div *ngIf="editing" class="ie-field__edit">
    <input
      #inlineEditControl
      class="ie-field__input"
      [maxLength]="maxLength"
      [(ngModel)]="value"
      (blur)="onBlur($event)"
      [name]="name"
      [type]="type"
      [required]="required"
      [placeholder]="label"
    />
    <i class="fa fa-check ie-field__confirm"></i>
  </div>
</div>
